import React from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";

import Navbar from './pages/Navbar';
import LoginPage from './pages/LoginPage';
import HomePage from './pages/HomePage';

import DBInsertPage from './pages/RawManagement/DBInsertPage';
import DBUpdatePage from './pages/RawManagement/DBUpdatePage';
import DBDeletePage from './pages/RawManagement/DBDeletePage';

import DBCreateTablePage from './pages/TableManagement/DBCreateTablePage';
import DBRenameTablePage from './pages/TableManagement/DBRenameTablePage';
import DBDeleteTablePage from './pages/TableManagement/DBDeleteTablePage';

import { UserProvider } from './pages/UserContext'; // importa qui

import "./App.css";

function App() {
  return (
    <React.StrictMode>
      <BrowserRouter>
        <UserProvider> {/* Contesto applicato a tutta l’app */}
          <Navbar />
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/login" element={<LoginPage />} />
            <Route path="/insert" element={<DBInsertPage />} />
            <Route path="/update" element={<DBUpdatePage />} />
            <Route path="/delete" element={<DBDeletePage />} />
            <Route path="/createTable" element={<DBCreateTablePage />} />
            <Route path="/renameTable" element={<DBRenameTablePage />} />
            <Route path="/deleteTable" element={<DBDeleteTablePage />} />
          </Routes>
        </UserProvider>
      </BrowserRouter>
    </React.StrictMode>
  );
}

export default App;
